import React from 'react'
import { ScrollToTop } from '../components/ScrollToTop'
import SignIn from '../components/Signin'

const Login = () => {
  return (
    <>
      <ScrollToTop />
      <SignIn />
    </>
  )
}

export default Login;
